import { render } from "./404.vue?vue&type=template&id=82158542"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/404.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "82158542"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('82158542', __exports__)) {
    console.log('reload')
    api.reload('82158542', __exports__)
  }
  
  module.hot.accept("./404.vue?vue&type=template&id=82158542", () => {
    console.log('re-render')
    api.rerender('82158542', render)
  })

}


export default __exports__